export const formatAddress = (address) => {
  if (!address || !Object.keys(address)?.length) return [];
  const firstLine = `${address.suite || ''}${address.suite ? '-' : ''}${
    address.streetNumber || ''
  }${address.streetNumber ? ' ' : ''} ${address.streetName || ''}`;

  const secondLine = `${address.city || ''}${address.city ? ', ' : ''} ${address.province || ''}${
    address.province ? ', ' : ''
  }${address.country || ''}`;
  const thirdLine = `${address.postalCode?.toUpperCase() || ''}`;
  return [firstLine, secondLine, thirdLine].map((str) => str.trim()).filter((str) => !!str);
};

export const formatAddressLine = (address) => {
  const arr = formatAddress(address);
  return arr.join(', ');
};
